export const environment = {
    useSentry: true,
    production: true,
    // Supplier v2 (Plan 1): off in production builds until Plans 1-2 are done.
    supplierV2: true,
    sandbox: false,
    apiUrl: 'https://api.staging.jetfueltenders.com',
    landingUrl: 'https://staging.jetfueltenders.com',
    docsUrl: 'https://staging.jetfueltenders.com/docs',
    sentryDSN: 'https://c5395ab0b76911fec13eb1f559846f3f@sentryv2.zitemedia.com/12',
    sentryEnvName: 'staging-frontend',
    websocketUrl: 'wss://api.staging.jetfueltenders.com',
    plausibleDomain: 'app.staging.jetfueltenders.com',
};
